import {RootState} from "./store";
import {createSelector} from "@reduxjs/toolkit";
import {initialState} from "./slice";

const calcState = (state: RootState) => state.calc

export const selectors = {
    selectIsStoppedByToDetails: createSelector(calcState, (state: typeof initialState) => state.is_stop_by_to_details),
    selectFeeFilter: createSelector(calcState, (state: typeof initialState) => state.feeFilter),
    selectHideNumFilter: createSelector(calcState, (state: typeof initialState) => state.hideNumFilter),
    selectHighlightFrom: createSelector(calcState, (state: typeof initialState) => state.highlightFrom),
    selectHiddenExchanges: createSelector(calcState, (state: typeof initialState) => state.hiddenExchanges),
    selectFilterPercent: createSelector(calcState, (state: typeof initialState) => state.filterPercent),
    selectIsToDetailsOpen: createSelector(calcState, (state: typeof initialState) => state.isToDetailsOpen),
    selectIsFavoriteOpen: createSelector(calcState, (state: typeof initialState) => state.isFavoriteOpen),
    selectIsSettingsOpen: createSelector(calcState, (state: typeof initialState) => state.isSettingsOpen),
    selectIsMenuOpen: createSelector(calcState, (state: typeof initialState) => state.isMenuOpen),
    selectIsPlay: createSelector(calcState, (state: typeof initialState) => state.isPlay),
    selectIsInfoOpen: createSelector(calcState, (state: typeof initialState) => state.isInfoOpen),
    selectSelectedItem: createSelector(calcState, (state: typeof initialState) => state.selectedItem),
    selectSelectedItemIndex: createSelector(calcState, (state: typeof initialState) => state.selectedItemIndex),
    selectCurrentToHistoryState: createSelector(calcState, (state: typeof initialState) => state.currentToHistoryState),
    selectSelectedPrecisions: createSelector(calcState, (state: typeof initialState) => state.selectedPrecisions),
    selectFavorites: createSelector(calcState, (state: typeof initialState) => state.favorites),
    selectDeleted: createSelector(calcState, (state: typeof initialState) => state.deleted),
    selectLang: createSelector(calcState, (state: typeof initialState) => state.lang),
    selectIsLangOpen: createSelector(calcState, (state: typeof initialState) => state.isLangOpen),
}